import RunQuery from './RunQuery';

export default RunQuery;
